import { Link, useLocation } from "react-router-dom";
import { Home, LayoutGrid, ShoppingCart, User } from "lucide-react";
import { cn } from "@/lib/utils";
import { useCart } from "@/context/CartContext";

const tabs = [
  { to: "/", label: "Home", icon: Home },
  { to: "/products", label: "Categories", icon: LayoutGrid },
  { to: "/cart", label: "Cart", icon: ShoppingCart, showBadge: true },
  { to: "/account", label: "Account", icon: User },
];

const BottomNav = () => {
  const { pathname } = useLocation();
  const { totalItems } = useCart();

  if (pathname === "/checkout") return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 md:hidden">
      <nav
        className="bg-background border-t border-border/50 shadow-[0_-2px_12px_-4px_hsl(var(--foreground)/0.08)]"
        style={{ paddingBottom: "env(safe-area-inset-bottom, 0px)" }}
      >
        <div className="flex items-center justify-around h-[56px]">
          {tabs.map((tab) => {
            const active = tab.to === "/"
              ? pathname === "/"
              : pathname.startsWith(tab.to);
            return (
              <Link
                key={tab.to}
                to={tab.to}
                aria-label={tab.label}
                className={cn(
                  "relative flex flex-col items-center justify-center gap-[3px] w-full h-full active:scale-90 transition-all duration-150",
                  active ? "text-primary" : "text-muted-foreground"
                )}
              >
                {active && (
                  <span className="absolute top-0 left-1/2 -translate-x-1/2 w-10 h-[3px] rounded-b-full bg-primary" />
                )}
                <span className="relative">
                  <tab.icon
                    className={cn("h-[22px] w-[22px]", active && "drop-shadow-sm")}
                    strokeWidth={active ? 2.5 : 1.8}
                    fill={active ? "currentColor" : "none"}
                  />
                  {tab.showBadge && totalItems > 0 && (
                    <span className="absolute -top-1.5 -right-2 flex h-[16px] min-w-[16px] items-center justify-center rounded-full bg-accent text-[8px] font-black text-accent-foreground px-0.5 shadow-sm">
                      {totalItems > 9 ? "9+" : totalItems}
                    </span>
                  )}
                </span>
                <span className={cn(
                  "text-[10px] leading-none",
                  active ? "font-extrabold" : "font-semibold"
                )}>{tab.label}</span>
              </Link>
            );
          })}
        </div>
      </nav>
    </div>
  );
};

export default BottomNav;
